import styled from "styled-components";

import { whiteBgOnClickAnim, scaleOnClickAnim } from "../../animations";

const RombSVG = require("../../../assets/shape.svg");

export const Title = styled.div`
  line-height: 1.4;
  margin-bottom: 35px;
  font-size: 20px;
  .nonce {
    height: 30px;
  }
  p,
  textarea {
    font-family: "GT America, regular";
    scrollbar-width: none;
    background: transparent;
    border: none;
    outline: none;
    color: transparent;
    text-shadow: 0 0 0 #ffb000;
    font-size: 18px;
    margin: auto;
    appearance: none;
    cursor: ${(p) => (p.copyCursor ? "default" : "copy")};
    width: 100%;
    max-width: 500px;
    resize: none;
    user-select: text !important;
    line-height: 1.4;
    font-weight: 300;
    :focus {
      outline-offset: 10px;
      outline: none;
      border: none;
      outline: 0;
    }
    ::selection {
      background: none;
      border: none;
      text-decoration-line: underline;
      :-moz-focus-inner {
        border: none;
        outline: none;
      }
    }
  }
`;
export const Button = styled.div`
  background: #ffb000;
  border: solid 3px #ffb000;
  border-radius: 38px;
  height: 56px;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  color: #4199ba;
  text-transform: uppercase;
  margin: 20px 0;
  position: relative;
  cursor: pointer;
  &&.disabled {
    pointer-events: none;
    opacity: 0.6;
  }
  :after {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    transform: scale(1);
    background: #ffffff;
    border: solid 3px #ffffff;
    border-radius: 38px;
    opacity: 0;
    right: 50%;
    bottom: 50%;
    transform: translate(50%, 50%);
    width: 100%;
    height: 100%;
    animation: ${(p) => (p.setA ? whiteBgOnClickAnim : null)};
    animation-duration: 0.5s;
  }
  animation: ${(p) => (p.setA ? scaleOnClickAnim : null)};
  animation-duration: 0.5s;
  pointer-events: ${(p) => (p.clickable || p.autoOn ? "none" : "auto")};
`;

export const SeedInput = styled.input`
  font-family: "GT America, regular";
  background: transparent;
  border: solid 3px;
  border-radius: 38px;
  height: 56px;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: all 0.5s;
  ${(p) =>
    p.notify && (p.clickable === true || p.autoOn === false)
      ? "color: #ff3920; border-color: #ff3920;"
      : "color: #ffb000; border-color: #ffb000;"}
  ${(p) =>
    p.clickable || p.autoOn
      ? "pointer-events: none; color: #ffb000; border-color: #ffb000;"
      : "pointer-events: auto"}
  &::placeholder {
    color: #ffb000;
  }
  outline: none;
`;

export const Description = styled.div`
  margin-bottom: 30px;
  line-height: 1.33;
  font-size: 26px;

  h3 {
    text-transform: uppercase;
    margin-bottom: 13px;
  }
  h4 {
    font-size: 20px;
  }
  p {
    font-size: 20px;
    font-family: "GT America, regular";
  }
`;
export const DetailedContainer = styled.div`
  border-radius: 18px;
  border: solid 3px #233b50;
  margin: auto auto 30px;
  width: 315px;
`;
export const DetailedDescription = styled.div`
  padding: 14px 20px;
  h4 {
    font-size: 20px;
    text-transform: uppercase;
    margin-bottom: 10px;
  }
  p {
    font-size: 12px;
  }
`;
export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  text-align: center;
  h4 {
    width: 50%;
    text-align: center;
    padding: 10px;
    border-top: solid 3px #233b50;
    border-bottom: solid 3px #233b50;
    text-transform: uppercase;
    :first-child {
      border-right: solid 3px #233b50;
    }
  }
`;
export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 50%;
  align-items: center;
  min-height: 188px;
  border-bottom: solid 3px #233b50;
  &&.centered {
    justify-content: center;
  }
  &&.border-b {
    border-bottom: none;
  }
  :first-child {
    border-right: solid 3px #233b50;
  }
`;
export const Box = styled.div`
  padding: 10px 0;
  border: solid 3px #ffb000;
  width: 120px;
  font-size: 12px;
  margin: 10px auto;
  text-transform: uppercase;
  position: relative;
  &&.round {
    border-radius: 23px;
  }
  svg {
    transform: translateY(1px) translateX(3px);
  }
  @media only screen and (min-width: 375px) {
    width: 120px;
    font-size: 12px;
  }
`;
export const Romb = styled.div`
  background: url(${RombSVG});
  font-size: 10px;
  position: relative;
  width: 120px;
  height: 36px;
  margin: 10px auto;
  text-transform: uppercase;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Circle = styled.div`
  width: 9px;
  height: 9px;
  border-radius: 50%;
  position: absolute;
  background: #4199ba;
  border: solid 1px #ffb000;
  z-index: 2;
  right: -5px;
  bottom: 50%;
  transform: translateY(50%);
  box-shadow: 0px 0px 0px 2px #ffb000;
  &&.left {
    right: unset;
    left: -5px;
  }
  &&.top {
    bottom: unset;
    top: -5px;
    right: 50%;
    transform: translateY(0) translateX(50%);
  }
  &&.bottom {
    bottom: -5px;
    right: 50%;
    transform: translateY(0) translateX(50%);
  }
  &&.rightCorner {
    bottom: -5px;
    right: -5px;
    transform: translateY(0);
  }
  &&.leftCorner {
    bottom: unset;
    top: -5px;
    left: -5px;
    transform: translateY(0);
  }
  &&.rightRomb {
    right: 5px;
  }
  &&.leftRomb {
    right: unset;
    left: 5px;
  }
`;
export const Line = styled.div`
  height: 3px;
  position: absolute;
  z-index: 1;
  background: #ffb000;
  bottom: 50%;
  right: -50px;
  width: 60px;
  transform: translateY(50%);
  &&.down {
    height: 35px;
    width: 3px;
    right: 50%;
    bottom: -35px;
    transform: translateY(0) translateX(50%);
  }
  &&.diagTop {
    bottom: 50%;
    transform-origin: left;
    width: 80px;
    right: -80px;
    transform: translateY(0) translateX(0) rotate(-57deg);
    @media only screen and (min-width: 375px) {
      width: 80px;
      right: -80px;
      transform: translateY(0) translateX(0) rotate(-57deg);
    }
  }
  &&.diagBot {
    width: 75px;
    right: -75px;
    bottom: 50%;
    transform: translateY(0) translateX(0) rotate(61deg);
    transform-origin: left;
    @media only screen and (min-width: 375px) {
      width: 80px;
      right: -80px;
      transform: translateY(0) translateX(0) rotate(57deg);
    }
  }
  &&.diagBotLong {
    width: 100px;
    right: -100px;
    transform: translateY(0) translateX(0) rotate(71deg);
    bottom: 0;
    transform-origin: left;
    @media only screen and (min-width: 375px) {
      transform: translateY(0) translateX(0) rotate(66deg);
    }
  }
`;
